export default __webpack_public_path__ + "static/shamir-4d37264acf5a5e73c200cbc6608fe989.svg";